import React, { ReactElement } from 'react';
import { useRouteMatch } from 'react-router-dom';

import StyledPrimaryNav from './styledPrimaryNav';

type PrimaryNavProps = {
  links: Array<link>;
};

type link = { label: string; route: string };

function NavItem({ link }: { link: link }) {
  const match = useRouteMatch({
    path: link.route,
    exact: true,
  });
  return (
    <li>
      <a href={link.route} className={match ? 'active' : ''}>
        {link.label}
      </a>
    </li>
  );
}

function PrimaryNav({ links }: PrimaryNavProps): ReactElement {
  return (
    <StyledPrimaryNav>
      {links.map(link => (
        <NavItem key={link.label} link={link} />
      ))}
    </StyledPrimaryNav>
  );
}

export { PrimaryNav };
